/** Compartilhar o link do estado atual. */
import { showToast } from '../state/toasts';
import { currentShareUrl, writeUrlNow } from '../state/urlSync';

export async function copyText(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    // Fallback para navegadores sem Clipboard API (ou sem permissão).
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    let ok = false;
    try {
      ok = document.execCommand('copy');
    } catch {
      ok = false;
    }
    ta.remove();
    return ok;
  }
}

/** No celular abre o menu de compartilhamento; senão copia o link. */
export async function shareCurrentView(): Promise<void> {
  writeUrlNow();
  const url = currentShareUrl();
  const touch = window.matchMedia('(pointer: coarse)').matches;
  if (touch && typeof navigator.share === 'function') {
    try {
      await navigator.share({
        title: 'AmaView — Amazônia em dados abertos',
        text: 'Veja a Amazônia pelo satélite GOES-19 no AmaView',
        url,
      });
      return;
    } catch (e) {
      if (e instanceof DOMException && e.name === 'AbortError') return;
    }
  }
  if (await copyText(url)) {
    showToast({ id: 'share', kind: 'success', message: 'Link copiado' });
  } else {
    showToast({ id: 'share', kind: 'warning', message: 'Não foi possível copiar. Copie o endereço da barra do navegador.' });
  }
}
